import React from 'react'
import PropType from 'prop-types'
import { useRecoilState } from 'recoil'
import { selectedResultsStateById } from '../../../recoil/state/results'
import { Checkbox } from 'mailup-web-components'

const ResultCheckbox = ({ id, loading }) => {
  const [checked, setChecked] = useRecoilState(selectedResultsStateById(id))

  return (
    <Checkbox
      checked={checked}
      disabled={loading}
      value={id}
      onChange={e => setChecked(e.target.checked)}
      className='test-selectMessage'
      data-mu-test='result__check'
    />
  )
}

ResultCheckbox.propTypes = {
  id: PropType.number,
  loading: PropType.bool
}

export default ResultCheckbox
